import { Component } from 'opus-angular-seed-core';

@Component({
    bindings: {
        room: '='
    },
    template: `
        <div class="heading01 type01">
            <h1>{{ 'planning.Add room' | translate }}</h1>
            <a ui-sref="authorized.courses.rooms.list()" class="btn discrete">{{ 'general.Back to list' | translate }}</a>
        </div>
        <courses-rooms-form form="vm.form" room="vm.room"/>
    `
})
export default class {
    constructor (FormFactory) {
        this.form = FormFactory.create(this.room, model => model.$save());
    }
}




// WEBPACK FOOTER //
// ./src/app/components/courses/rooms/add/index.js